/* Extracted from snippets/product-quick-specs.liquid on 2026-08-15.
   Was inline in every document that renders this file; now fetched once and
   cached. Deferred, so it runs after the DOM is parsed rather than at its old
   position — safer for the DOM queries inside, not riskier.
   No Liquid in here, which is why it could move at all. */

(function () {
      const dataEl = document.getElementById('VariantSpecsData');
      if (!dataEl) return;
      let specMap;
      try {
        specMap = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      const applySpecs = (variantId) => {
        const specs = specMap[variantId];
        if (!specs) return;
        for (const node of document.querySelectorAll('[data-spec-slot]')) {
          const slot = node.dataset.specSlot;
          /* The row, where one is marked. A measurement that differs between
             sizes is absent from specs for any size we have no figure for, and
             its row is hidden rather than left showing another size's number.
             Rows without the marker are never hidden, so a spec that is the
             same whatever you pick behaves exactly as it always did. */
          const row = node.closest('[data-spec-row]');
          if (Object.prototype.hasOwnProperty.call(specs, slot)) {
            node.textContent = specs[slot];
            if (row) row.hidden = false;
          } else if (row) {
            node.textContent = '';
            row.hidden = true;
          }
        }
      };

      document.addEventListener('variant:change', (event) => {
        const detail = event.detail || {};
        const id = detail.variantId || (detail.variant && detail.variant.id);
        if (id) applySpecs(id);
      });
    })();
